import React from 'react';

export default function VacancyEmpty({ children, style = {} }) {
  return (
    <div style={style} className="flex justify-center font-bold opacity-50 h-20 items-center">
      {children}
    </div>
  );
}
